import jfetch from "../utils/jfetch";
import { snakeCaseKeys } from "../utils";
import { normalizeRecord } from "./api_utils";

/**
 * Technically only gets all PUBLISHED courses right now
 */
export function getAllCourses(): Promise<ICourse[]> {
  return jfetch
    .get("/library/courses", {'ranked': 'alphabetical'})
    .then(resp => resp.data.map(normalizeCourse));
}

export function getAllCoursesCategorySorted(opts?: any) {
  return jfetch.get("/library/courses", opts);
}

export function normalizeCourse(course: ICourseRecord): ICourse {
  return normalizeRecord(course);
}

export function assignCourseToUser(courseId: string, userId: string) {
  return jfetch.post(
    `/library/courses/${courseId}/assign`,
    snakeCaseKeys({ userId })
  );
}

/**
 * Fetches a list of courses from the API
 * @param courseIds
 */
export function getCourses(courseIds: string[]) {
  return Promise.all(courseIds.map(c => getCourse(c)));
}

/**
 * Fetches a single course from the API
 * @param courseId
 */
export function getCourse(courseId: string) {
  return jfetch
    .get(`/library/courses/${courseId}`)
    .then(resp => normalizeCourse(resp.data));
}

export function getUserCourseProgress(courseId, userId): Promise<number> {
  return jfetch
    .get(
      `/library/courses/${courseId}/user_progress`,
      snakeCaseKeys({ userId })
    )
    .then(resp => resp.percent_complete);
}

export function setCoursesOrder(courseOrder: string[], categoryId: string) {
  return jfetch.post(
    "/library/courses/set_order",
    snakeCaseKeys({ courseOrder: courseOrder, categoryId: categoryId })
  );
}



// WEBPACK FOOTER //
// ./app/javascript/libs/courses.ts